/*
 * @Date: 2020-03-09 21:30:19
 * @LastEditors: miaomiaodeng
 * @LastEditTime: 2020-03-11 11:42:30
 * @FilePath: /rongxin.web/src/views/home/product-service/index.js
 */
import Service from './servece.js';
export default {
  name: 'newsCenter',
  data() {
    return {
      params: {
        limit: '10',
        homePage: 1, // 只查首页推荐且已发布状态的数据
        status: 1, // 已发布状态
        clientId: '6188e0dbc2d92675c94f5598',
        catalogId: '6188e618c2d92675c94f559a',
        source: 'guanWang'
      },
      newsArr: [],
      headNews: [],
      headlines: {
        // date: '09-12',
        // title: '最新动态标题最新动态标题最新动态标题最',
        // content: '2020年5月22日，金秀县政府发文推广“春耕”APP，推动金秀县域金融发展，为当地农户融资开拓全新的渠道。“春耕”APP，是金秀县农村数字金融客户端，让金融科技为“三农”发展带来全新的变革，老百姓足不出户也能享受科技创新带来的红利，助力乡村振兴建设。'
      }
    };
  },
  created() {
    this.getNewsList();
  },
  methods: {
    getNewsList() {
      Service.getNewsList(this.params).then(data => {
        this.newsArr = data.data && data.data.list.slice(1, 4);
        this.headNews = data.data && data.data.list.slice(0, 1);
      });
    },
    // 企业动态二级页面
    goEnterprise() {
      this.$router.push({
        path: 'enterpriseNewsDetail'
      });
    },
    // 企业动态三级页面
    goDetailNews(id, guanWang) {
      this.$router.push({
        path: 'enterpriseDetailNews',
        query: {
          id: id,
          guanWang
        }
      });
    }
  }
};
